// App shell (sidebar, top bar) and the sign-in / profile screens.
export const shellEn = {
  'shell.brandName': 'Digimasi Console',
  'shell.brandSub': 'Platform management',
  'shell.nav.dashboard': 'Dashboard',
  'shell.nav.sites': 'Sites',
  'shell.nav.staff': 'Staff',
  'shell.nav.audit': 'Audit log',
  'shell.nav.group.overview': 'Overview',
  'shell.nav.group.platform': 'Platform',
  'shell.searchMenu': 'Search menu',
  'shell.openMenu': 'Open menu',
  'shell.closeMenu': 'Close menu',
  'shell.menuTitle': 'Menu',
  'shell.account': 'Account',
  'shell.profile': 'Profile',
  'shell.theme': 'Theme',
  'shell.themeLight': 'Light',
  'shell.themeDark': 'Dark',
  'shell.themeSystem': 'System',
  'shell.signOut': 'Sign out',
  'auth.login.title': 'Sign In',
  'auth.login.subtitle': 'Console access is for platform staff only.',
  'auth.login.email': 'Email',
  'auth.login.password': 'Password',
  'auth.login.submit': 'Sign in',
  'auth.login.submitting': 'Signing in…',
  'auth.login.captchaHint': 'Complete the check above to sign in.',
  'auth.profile.title': 'Profile',
  'auth.profile.changePassword': 'Change Password',
  'auth.profile.changePasswordHint': 'Changing your password signs out every other session.',
  'auth.profile.current': 'Current password',
  'auth.profile.new': 'New password',
  'auth.profile.newHint': 'At least {min} characters',
  'auth.profile.confirm': 'Confirm new password',
  'auth.profile.mismatch': 'Passwords do not match',
  'auth.profile.submit': 'Change password',
  'auth.profile.changed': 'Password changed. Other sessions were signed out.',
} as const

export const shellId: Record<keyof typeof shellEn, string> = {
  'shell.brandName': 'Digimasi Console',
  'shell.brandSub': 'Manajemen platform',
  'shell.nav.dashboard': 'Dasbor',
  'shell.nav.sites': 'Situs',
  'shell.nav.staff': 'Staf',
  'shell.nav.audit': 'Log audit',
  'shell.nav.group.overview': 'Ikhtisar',
  'shell.nav.group.platform': 'Platform',
  'shell.searchMenu': 'Cari menu',
  'shell.openMenu': 'Buka menu',
  'shell.closeMenu': 'Tutup menu',
  'shell.menuTitle': 'Menu',
  'shell.account': 'Akun',
  'shell.profile': 'Profil',
  'shell.theme': 'Tema',
  'shell.themeLight': 'Terang',
  'shell.themeDark': 'Gelap',
  'shell.themeSystem': 'Sistem',
  'shell.signOut': 'Keluar',
  'auth.login.title': 'Masuk',
  'auth.login.subtitle': 'Akses console hanya untuk staf platform.',
  'auth.login.email': 'Email',
  'auth.login.password': 'Kata sandi',
  'auth.login.submit': 'Masuk',
  'auth.login.submitting': 'Sedang masuk…',
  'auth.login.captchaHint': 'Selesaikan cek di atas untuk masuk.',
  'auth.profile.title': 'Profil',
  'auth.profile.changePassword': 'Ubah Kata Sandi',
  'auth.profile.changePasswordHint': 'Mengubah kata sandi akan mengeluarkan semua sesi lainnya.',
  'auth.profile.current': 'Kata sandi saat ini',
  'auth.profile.new': 'Kata sandi baru',
  'auth.profile.newHint': 'Minimal {min} karakter',
  'auth.profile.confirm': 'Konfirmasi kata sandi baru',
  'auth.profile.mismatch': 'Kata sandi tidak cocok',
  'auth.profile.submit': 'Ubah kata sandi',
  'auth.profile.changed': 'Kata sandi diubah. Sesi lainnya telah dikeluarkan.',
}
